import React from "react";
import styled from "styled-components";
import t from "common/i18n";
import { globalTheme } from "@cld/component-theme";

const SectionBox = styled.section`
	padding: ${globalTheme.spacing.md};
	> label {
		font-weight: bold;
		white-space: nowrap;
		display: block;
		padding-bottom: ${globalTheme.spacing.xs};
		font-size: ${globalTheme.font.size.xs};
	}
`;

const SectionLine = styled.div`
	display: flex;
	padding-bottom: ${globalTheme.spacing.sm};
	label {
		display: block;
		width: 100px;
	}
	span {
		color: ${globalTheme.palette.secondary};
	}
`;


export default ({ selectedAsset, selectedProduct }) => {
	return (<SectionBox>
		{selectedProduct?.type === "creditpack" && <SectionLine>
			<label>{t("istock.purchase.cost")}</label>
			<span>{selectedAsset.creditPrice} {t(`istock.purchase.credit${selectedAsset.creditPrice > 1 ? "s" : "" }`)}</span>
		</SectionLine>}
		<SectionLine>
			<label>{t("istock.purchase.credit")}</label>
			<span>{selectedAsset.artist}</span>
		</SectionLine>
		<SectionLine>
			<label>{t("istock.purchase.collection")}</label>
			<span>{selectedAsset.collectionCode}</span>
		</SectionLine>
		<SectionLine>
			{selectedAsset.isVideo && <label>{t("istock.purchase.istock_video_id")}</label>}
			{!selectedAsset.isVideo && <label>{t("istock.purchase.istock_photo_id")}</label>}
			<span>{selectedAsset.id}</span>
		</SectionLine>
	</SectionBox>);
};
